import { NotificationFeedbackType, notificationFeedbackTypeAsString, notificationFeedbackTypeAsColor } from '@leedpulse-monorepo/enums';
import { formatNumber } from '@leedpulse-monorepo/utils';

const NotificationsFeedbackChart = ({ stats, loading }: { stats: Record<NotificationFeedbackType, number>, loading: boolean }) => {
  if (loading) {
    return (
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <div style={{ fontSize: '12px', color: '#888' }}>Chargement...</div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  // Calculate total for percentage
  const total = Object.values(stats).reduce((sum, count) => sum + count, 0);

  if (total === 0) {
    return (
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <div style={{ fontSize: '12px', color: '#888' }}>Aucune donnée</div>
      </div>
    );
  }

  // Order feedback types for display
  const feedbackTypes = [
    NotificationFeedbackType.APPOINTMENT_SCHEDULED,
    NotificationFeedbackType.TO_BE_CONTINUED,
    NotificationFeedbackType.UNREACHABLE,
    NotificationFeedbackType.NOTHING_TO_DO,
  ];

  return (
    <div style={{ padding: '0' }}>
      {feedbackTypes.map((feedbackType) => {
        const count = stats[feedbackType] || 0;
        const percentage = total > 0 ? (count / total) * 100 : 0;
        const color = notificationFeedbackTypeAsColor(feedbackType);
        const label = notificationFeedbackTypeAsString(feedbackType);

        return (
          <div
            key={feedbackType}
            style={{
              marginBottom: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            <div
              style={{
                width: '120px',
                fontSize: '11px',
                color: '#666',
                textAlign: 'right',
                flexShrink: 0,
              }}
            >
              {label}
            </div>
            <div
              style={{
                flex: 1,
                height: '20px',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px',
                overflow: 'hidden',
                position: 'relative',
                minWidth: 0,
              }}
            >
              <div
                style={{
                  width: `${percentage}%`,
                  height: '100%',
                  backgroundColor: color,
                  transition: 'width 0.3s ease',
                }}
              />
            </div>
            <div
              style={{
                width: '35px',
                fontSize: '12px',
                fontWeight: '600',
                color: '#000',
                textAlign: 'right',
                flexShrink: 0,
              }}
            >
              {formatNumber(count)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default NotificationsFeedbackChart;
